/**
 * @author wuhao
 * 患者模块
 */
import {getOutPatientListApi,quickPrescriptionApi,getPatientInfoApi,getWaitOutpatientNumApi,savePatientInfoApi,getDoctorVisitApi} from "@/api/patient";
import _ from 'lodash';
class Patient {
    //左边患者列表
    static getOutPatientList(obj){
        return new Promise((resolve,reject)=>{
            getOutPatientListApi(obj).then(res=>{
                if(res.code==200){
                    resolve(res)
                }
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //快捷开方
    static quickPrescription(obj){
        return new Promise((resolve,reject)=>{
            quickPrescriptionApi(obj).then(res=>{
                if(res.code==200){
                    resolve(res)
                }
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //查看患者详情
    static getPatientInfo(obj){
        return new Promise((resolve,reject)=>{
            getPatientInfoApi(obj).then(res=>{
                if(res.code==200){
                    resolve(res)
                }
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //获取待诊数量
    static getOutpatientNum(obj){
        return new Promise((resolve,reject)=>{
            getWaitOutpatientNumApi(obj).then(res=>{
                if(res.code==200){
                    resolve(res)
                }
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //选择患者后保存患者
    static savePatientInfo(obj){
        return new Promise((resolve,reject)=>{
            savePatientInfoApi(obj).then(res=>{
                if(res.code==200){
                    resolve(res)
                }
            }).catch(err=>{
                reject(err)
            })
        })
    }
    //获取患者是新诊还是回诊
    static getDoctorVisit(obj){
        return new Promise((resolve,reject)=>{
            getDoctorVisitApi(obj).then(res=>{
                if(res.code==200){
                    resolve(res)
                }
            }).catch(err=>{
                reject(err)
            })
        })
    }
    

}
export {Patient}